import React from "react";
import SalaryViewBlock from "../../components/Salary/SalaryViewBlock";

const SalaryOverviewPage: React.FC<{}> = (props) => {
  return <SalaryViewBlock />;
};

export default SalaryOverviewPage;
